import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dpg-sub-notice',
  templateUrl: './notice.component.html',
  styleUrls: ['./notice.component.scss']
})
export class DpgSubNoticeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
